import React from "react";
import { BoxProps, SxProps } from "@mui/material";
import muiVariables from "../../styles/mui-variables";

const SelectDropdownStyle = {
  mainBox: {
    display: "flex",
    flexDirection: "column",
    m: 0,
    width: "100%",
    textAlign: "left",
  } as BoxProps,
  selectLabel: {
    margin: "0px 0px 8px 0px",
    fontWeight: "600",
    fontSize: muiVariables.subHeadingFontSize,
    lineHeight: "17.07px",
    color: `${muiVariables.subTextColor}`,
  } as React.CSSProperties,
  customSelectStyles: {
    control: (base: any, state: { isFocused: boolean }) => ({
      ...base,
      background: `${muiVariables.avatarBgColor}`,
      minHeight: "38px",
      height: "38px",
      fontSize: muiVariables.subHeadingFontSize,
      fontWeight: 400,
      borderRadius: 6,
      border: "none",
      cursor: "pointer",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? `${muiVariables.progressFillColor}` : "",
      },
    }),
    menu: (base: any) => ({
      ...base,
      borderRadius: 0,
      marginTop: 0,
      fontSize: muiVariables.subHeadingFontSize,
      fontWeight: 400,
      zIndex: 9999,
    }),
    menuList: (base: any) => ({
      ...base,
      padding: 0,
      fontSize: muiVariables.subHeadingFontSize,
      fontWeight: 400,
      border: `1px solid ${muiVariables.borderColor}`,
      boxShadow: "0px 40px 64px 0px rgba(12, 12, 12, 0.08)",
    }),
    placeholder: (base: any) => ({
      ...base,
      fontSize: muiVariables.subHeadingFontSize,
      fontWeight: 400,
    }),
    indicatorSeparator: (base: any) => ({
      ...base,
      display: "none",
    }),
    dropdownIndicator: (base: any) => ({
      ...base,
      color: `${muiVariables.mainTextColor} !important`,
    }),
  },
  errorMessage: {
    marginTop: "5px !important",
    textAlign: "start",
    color: `${muiVariables.errorMessageColor} !important`,
  } as SxProps,
};

export default SelectDropdownStyle;
